"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_table_1 = __importDefault(require("react-table"));
var react_table_hoc_fixed_columns_1 = __importDefault(require("react-table-hoc-fixed-columns"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var SellerGroupModelListPagination_1 = __importDefault(require("./SellerGroupModelListPagination"));
var SearchResultHeader_1 = __importDefault(require("../../common/SearchResultHeader"));
var RefreshDataSpinner_1 = __importDefault(require("../../common/RefreshDataSpinner"));
var util_1 = require("@aperza/util");
var ui_1 = require("@aperza/ui");
var react_device_detect_1 = require("react-device-detect");
var SellerGroupModelListGroupSelection_1 = __importDefault(require("./SellerGroupModelListGroupSelection"));
var SellerGroupModelListFilter_1 = __importDefault(require("./SellerGroupModelListFilter"));
var appConfig = util_1.AppService.appConfig();
var ReactTableFixedColumns = react_table_hoc_fixed_columns_1.default(react_table_1.default);
// This is for 2 MAIN Columns (Seller Model Number + Price + Shipping)
var getMainColumnWidth = function (rows, accessor, headerText) {
    var maxWidth = 400;
    var magicSpacing = 10;
    // Unescape encodeURIComponent is to check japanese character as well
    var rowData = rows.map(function (row) { return unescape(encodeURIComponent("" + row[accessor] || '')).length; });
    if (rowData === undefined || rowData.length === 0) {
        return; // use default size if there is no data available
    }
    var cellLength = Math.max.apply(Math, __spreadArrays(rowData, [headerText.length]));
    // Add 20px spacing for the help icons
    return Math.min(maxWidth, cellLength * magicSpacing + 20);
};
// This is for spec columns other than the 3 main columns
var getColumnWidth = function (rows, specId, headerText) {
    var maxWidth = 500;
    var magicSpacing = 8;
    var index = getSpecIndex(rows[0], specId);
    // Unescape encodeURIComponent is to check japanese character as well
    var rowData = rows
        .filter(function (row) { return row.specs[index]; })
        .map(function (row) {
        return unescape(encodeURIComponent(row.specs[index].specValue || '')).length;
    });
    if (rowData === undefined || rowData.length === 0) {
        return; // use default size if there is no data available
    }
    var cellLength = Math.max.apply(Math, __spreadArrays(rowData, [unescape(headerText).length]));
    var columnWidth = cellLength * magicSpacing;
    return Math.min(maxWidth, columnWidth > 100 ? columnWidth : 100);
};
var getSpecIndex = function (row, value) {
    var specs = row.specs;
    for (var i = 0; i < specs.length; i++)
        if (specs[i].specId === value)
            return i;
    return -1;
};
var SellerGroupModelList = /** @class */ (function (_super) {
    __extends(SellerGroupModelList, _super);
    function SellerGroupModelList(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchPossibleSpecValues = function (specIdAndValues) {
            // ***************************** FETCH
            var apiHost = util_1.AppConfigService.getApiHostname();
            var jsonBody = JSON.stringify({
                sellerModelId: _this.state.sellerModelId,
                sellerContactId: _this.state.sellerContactId,
                specIdAndValues: specIdAndValues,
            });
            fetch(apiHost + "/v2/product/seller/spec/uniqueSpecs", {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: jsonBody,
            })
                .then(function (res) { return res.json(); })
                .then(function (result) {
                var _a;
                if (result && result.data) {
                    _this.setState({
                        isLoaded: true,
                        filterSuggestions: (_a = result.data.specIdAndValues) !== null && _a !== void 0 ? _a : [],
                    });
                }
                else {
                    console.warn("unable to fetch specData for request (with 200 response): " + jsonBody);
                }
            }, 
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            function (error) {
                console.error("unable to fetch specData for request: " + jsonBody);
                _this.setState({
                    isLoaded: true,
                    error: error,
                });
            });
        };
        _this.updateLimit = function (limit) {
            _this.setState({ limit: parseInt(limit) });
        };
        _this.changeGroup = function (sellerProductGroupId) {
            _this.setState({ sellerProductGroupId: sellerProductGroupId });
        };
        _this._refetch = function (state) { return __awaiter(_this, void 0, void 0, function () {
            var selectedFilters, specs, _i, _a, filter, selectedSellerGroupId, parsedLimit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        selectedFilters = {};
                        specs = [];
                        for (_i = 0, _a = state.filtered; _i < _a.length; _i++) {
                            filter = _a[_i];
                            if (Number.isInteger(parseInt(filter.id, 10))) {
                                // all spec id's are number based, all other fields are based on name
                                specs.push({ specId: filter.id, specValue: filter.value.trim() });
                            }
                            else {
                                selectedFilters[filter.id] = filter.value.trim();
                            }
                        }
                        if (specs.length) {
                            // there is a spec filter
                            selectedFilters.specs = specs;
                        }
                        selectedSellerGroupId = state.sellerProductGroupId === undefined
                            ? this.state.sellerProductGroupId
                            : state.sellerProductGroupId;
                        parsedLimit = state.limit ? state.limit : this.state.limit;
                        if (!this.props.refetch) return [3 /*break*/, 2];
                        this.setState({ loading: true });
                        return [4 /*yield*/, this.props.refetch({
                                sellerContactId: this.state.sellerContactId,
                                sellerModelId: this.state.sellerModelId,
                                sellerProductGroupId: parseInt(selectedSellerGroupId),
                                sellerModelNumber: selectedFilters['sellerModelNumber'],
                                specs: JSON.stringify(specs),
                                offset: state.page + 1,
                                limit: parsedLimit,
                                stocks: selectedFilters['stocks'],
                                price: selectedFilters['price'],
                                shippingDate: selectedFilters['shippingDate'],
                            })];
                    case 1:
                        _b.sent();
                        this.setState({ loading: false });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.columns = [];
        _this.cachedRequestSpecs = [];
        _this.state = {
            loading: true,
            data: _this.props.searchSeller.searchSellerGroup,
            sellerContactId: _this.props.sellerContactId,
            sellerModelId: _this.props.sellerModelId,
            sellerProductGroupId: null,
            filtered: [],
            limit: 10,
            page: 0,
            filterSuggestions: [],
        };
        return _this;
    }
    SellerGroupModelList.prototype.getCurrentModel = function (models) {
        if (models !== undefined && models.length > 0) {
            var currentModelIndex = 0;
            for (var _i = 0, _a = models.entries(); _i < _a.length; _i++) {
                var _b = _a[_i], modelIndex = _b[0], model = _b[1];
                if (model.sellerModelId === this.state.sellerModelId) {
                    currentModelIndex = modelIndex;
                }
            }
            return models[currentModelIndex];
        }
        return null;
    };
    SellerGroupModelList.prototype.doesCurrentModelHaveSpecGroups = function (models) {
        if (this.getCurrentModel(models) == null) {
            return false;
        }
        var groupSpecs = this.getCurrentModel(models).groupSpecs;
        return groupSpecs !== undefined && groupSpecs.length !== 0;
    };
    SellerGroupModelList.prototype.currentModelHasMultipleGroups = function (groups) {
        return groups !== undefined && groups.length > 1;
    };
    SellerGroupModelList.prototype.createColumns = function (models) {
        // if there are no models matched, get the last known state of the columns
        if (!this.doesCurrentModelHaveSpecGroups(models) &&
            this.columns !== undefined &&
            this.columns.length !== 0) {
            // return last known columns;
            return this.columns;
        }
        this.columns = [
            {
                Header: react_1.default.createElement(ui_1.Message, { messageId: "groupModelList.column.modelNumber" }),
                id: 'sellerModelNumber',
                accessor: function (d) { return d; },
                Cell: function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ui_1.WebMediaQuery, { desktopOnly: true },
                        react_1.default.createElement("a", { className: "number td-click", "data-track": '{"action":"aperza_send_to_item"}', href: appConfig.marketplaceWebHost + "/" + appConfig.langCode + "/d/i/" + props.value.sellerModelNumber + "/" + props.value.sellerModelId + ".html" },
                            react_1.default.createElement("p", { "data-tip": props.value.allModelSpecsIsPresentInGroup
                                    ? props.value.sellerProductGroupName
                                    : '' },
                                props.value.sellerModelNumber,
                                ' ',
                                props.value.allModelSpecsIsPresentInGroup && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faInfoCircle }))))),
                    react_1.default.createElement(ui_1.WebMediaQuery, { mobileOnly: true },
                        react_1.default.createElement("a", { className: "number td-click", "data-track": '{"action":"aperza_send_to_item"}', href: appConfig.marketplaceWebHost + "/" + appConfig.langCode + "/d/i/" + props.value.sellerModelNumber + "/" + props.value.sellerModelId + ".html" }, props.value.sellerModelNumber),
                        react_1.default.createElement("p", { style: { display: 'inline-block', margin: '0px 0px 0px 8px' }, "data-tip": props.value.allModelSpecsIsPresentInGroup
                                ? props.value.sellerProductGroupName
                                : '' }, props.value.allModelSpecsIsPresentInGroup && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faInfoCircle })))),
                    react_1.default.createElement(react_tooltip_1.default, { place: "right", type: "warning" }))); },
                width: getMainColumnWidth(models, 'sellerModelNumber', '型式'),
                sortable: false,
                filterable: true,
                Filter: function (_a) {
                    var filter = _a.filter, onChange = _a.onChange;
                    return (react_1.default.createElement("div", { className: "filterIcon" },
                        react_1.default.createElement("input", { type: 'text', onChange: function (event) { return onChange(event.target.value); } }),
                        react_1.default.createElement("i", { className: "fa fa-filter" })));
                },
            },
            {
                Header: react_1.default.createElement(ui_1.Message, { messageId: "groupModelList.column.price" }),
                id: 'price',
                accessor: function (d) { return d; },
                Cell: function (props) { return (react_1.default.createElement("div", { style: { textAlign: 'right' } },
                    react_1.default.createElement(ui_1.Price, { currency: 'JPY', price: props.value.price, openPrice: props.value.openPrice }))); },
                width: getMainColumnWidth(models, 'lowestOfferPrice', 'lowestOfferPrice'),
                className: 'price',
                filterable: false,
                sortable: false,
            },
            {
                Header: react_1.default.createElement(ui_1.Message, { messageId: "groupModelList.column.stocks" }),
                id: 'stocks',
                accessor: function (d) { return d; },
                Cell: function (props) { return (react_1.default.createElement("div", { style: { textAlign: 'center' } },
                    react_1.default.createElement(ui_1.StockLabel, { numberOfStocks: props.value.stocks, salesMethodMaker: props.value.salesMethodMaker, salesMethodLabel: props.value.salesMethodLabel }))); },
                width: getMainColumnWidth(models, 'lowestOfferPrice', 'lowestOfferPrice'),
                filterable: false,
                sortable: false,
            },
            {
                Header: react_1.default.createElement(ui_1.Message, { messageId: "groupModelList.column.shippingDate" }),
                // accessor: 'shippingDate',
                id: 'shippingDate',
                accessor: function (d) { return d; },
                Cell: function (props) { return react_1.default.createElement("div", { style: { textAlign: 'center' } }, props.value.shippingDate); },
                width: getMainColumnWidth(models, 'shippingDate', 'Shipping Date'),
                filterable: false,
                sortable: false,
            },
        ];
        if (!react_device_detect_1.isMobile) {
            // set first column (seller model number) to be fixed for DESKTOPS
            this.columns[0].fixed = 'left';
        }
        var parentColumns = this.columns;
        var self = this;
        this.getCurrentModel(models).groupSpecs.reduce(function (map, obj) {
            var availableSpecsForSpecId = [];
            for (var i = 0; i < self.state.filterSuggestions.length; i++) {
                if (self.state.filterSuggestions[i].specId === obj.specId) {
                    availableSpecsForSpecId = self.state.filterSuggestions[i].specValues;
                    break;
                }
            }
            parentColumns.push({
                Header: obj.specName,
                id: obj.specId + '',
                accessor: function (d) {
                    var specsRowMap = d.specs.reduce(function (map, obj) {
                        map[obj.specId] = obj.specValue;
                        return map;
                    }, {});
                    return specsRowMap[obj.specId];
                },
                Cell: function (row) { return (react_1.default.createElement("div", { className: 'spec_' + obj.specId, style: { textAlign: 'center' } }, row.value)); },
                //        width: getColumnWidth(models, obj.specId, obj.specName),
                sortable: false,
                filterable: true,
                Filter: function (_a) {
                    var filter = _a.filter, onChange = _a.onChange;
                    return (react_1.default.createElement(SellerGroupModelListFilter_1.default, { filter: filter, onChangeFromSpecTable: onChange, specId: obj.specId, filterSuggestions: availableSpecsForSpecId }));
                },
            });
        }, {});
        return this.columns;
    };
    SellerGroupModelList.prototype.render = function () {
        var _this = this;
        var data = this.props.searchSeller.searchSellerGroup;
        if (!data || !data.models || !data.groups) {
            return null;
        }
        var models = data.models;
        var pageMetadata = data.pageMetadata;
        var groups = data.groups;
        var reactTable = null;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(SearchResultHeader_1.default, { pageMetadata: pageMetadata, updateLimit: this.updateLimit }),
            this.currentModelHasMultipleGroups(groups) && (react_1.default.createElement(SellerGroupModelListGroupSelection_1.default, { groups: groups, changeGroup: this.changeGroup })),
            react_1.default.createElement(ReactTableFixedColumns, { loadingText: react_1.default.createElement(ui_1.Message, { messageId: "groupModelList.loadingText" }), LoadingComponent: RefreshDataSpinner_1.default, noDataText: react_1.default.createElement(ui_1.Message, { messageId: "groupModelList.noDataText" }), filterable: true, manual: true, data: models, PaginationComponent: SellerGroupModelListPagination_1.default, resizable: !react_device_detect_1.isMobile, pages: pageMetadata.noOfPages, columns: this.createColumns(models), pageSize: this.state.limit, onFetchData: this._refetch, loading: this.state.loading, className: "-highlight", onFilteredChange: function (filtered) {
                    if (filtered !== undefined && filtered.length > 0) {
                        var specIdAndValues = filtered.map(function (filter) { return ({
                            specId: filter.id,
                            specValue: filter.value,
                        }); });
                        var specIdAndValueKey = filtered
                            .map(function (filter) { return filter.value + '|' + filter.id; })
                            .reduce(function (accumulator, b) { return accumulator + '-' + b; });
                        // add a cache since onFocus triggers, this event and we don't want to make ajax call
                        if (!_this.cachedRequestSpecs.includes(specIdAndValueKey)) {
                            _this.fetchPossibleSpecValues(specIdAndValues);
                            _this.cachedRequestSpecs.push(specIdAndValueKey);
                        }
                        else {
                        }
                    }
                    else {
                        _this.fetchPossibleSpecValues([]);
                    }
                } })));
    };
    SellerGroupModelList.prototype.componentDidMount = function () {
        this._refetch({ filtered: [], page: 0, limit: this.state.limit });
        this.fetchPossibleSpecValues();
    };
    SellerGroupModelList.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.limit !== prevState.limit ||
            this.state.sellerProductGroupId !== prevState.sellerProductGroupId) {
            // prevState.page = 0;
            // this.setState({page: 0, limit: this.state.limit});     // initialize to 0 when selecting new limit or group
            this._refetch(this.state); // state is already updated
        }
    };
    return SellerGroupModelList;
}(react_1.default.Component));
exports.default = SellerGroupModelList;
